<div class="col-xs-12">
  <section id="section-we-are-finzy" class="row section-we-are-finzy">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">We are finzy</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">finzy is India's premier peer to peer lending portal. We have been consistently delivering returns over <strong class="black-text">10%</strong> since our inception in 2017.</p>
    </div>

    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <div class="row custcontainer finzy-description" id="howitworks">
          <div class="how-finzy-works-wrapper">
              <div class="icon-div finzy-icon-div">
                  <div class="icon-inner-div">
                      <img class="finzy-how-image" src="../../../../../assets/images/finzy-flex-dashboard/hand-picked-borrowers.svg" alt="hand-picked-borrowers"/>
                  </div>
                  <div class="finzy-description-wrapper">
                      <span class="finzy-desc-label">
                          Hand Picked Borrowers
                      </span>
                      <span class="finzy-how-description">
                          Our sourcing methods and proprietary credit algorithm
                              ensures that you get access to prime borrowers.
                      </span>
                  </div>
              </div>
              <div class="icon-div finzy-icon-div">
                  <div class="icon-inner-div">
                      <img class="finzy-how-image" src="../../../../../assets/images/finzy-flex-dashboard/diversified-investment.svg" alt="diversified-investment">
                  </div>
                  <div class="finzy-description-wrapper">
                      <span class="finzy-desc-label">
                          Diversified Investments
                      </span>
                      <span class="finzy-how-description">
                          Your investments are split into multiple loans at the 
                          click of a button.
                      </span>
                  </div>
              </div>
              <div class="icon-div finzy-icon-div">
                  <div class="icon-inner-div">
                      <img class="finzy-how-image" src="../../../../../assets/images/finzy-flex-dashboard/calender-monthly.svg" alt="calender-monthly" />
                  </div>
                  <div class="finzy-description-wrapper">
                      <span class="finzy-desc-label">
                          Regular Monthly Returns
                      </span>
                      <span class="finzy-how-description">
                          Now you can start earning EMIs. Your investments with finzy help you receive monthly returns.
                      </span>
                  </div>
              </div>
      
          </div>
      </div>
      </div>
    </div>
  </section>

  <section id="section-finzy-takes-care" class="row">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">finzy takes care of your investments</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">finzy helps you invest in a new asset class by connecting you with the right borrowers. You earn monthly returns by investing in personal loans that are risk optimized</p>
    </div>

    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-3 col-sm-6 subsection">
            <img src="../../../../../assets/images/finzy-flex-dashboard/trusted_platform.svg"
                 alt="You can trust finzy"
                 class="img-responsive icon">
            <p class="heading">Trusted Platform</p>
            <p class="description">finzy is an NBFC - P2P registered with RBI and our escrow accounts are <strong>Managed by ICICI Bank Trusteeship.</strong></p>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-3 col-sm-6 subsection">
            <img src="../../../../../assets/images/finzy-flex-dashboard/secure-document.svg"
                 alt="We ensure secure documentation"
                 class="img-responsive icon">
            <p class="heading">Secure Documentation</p>
            <p class="description">Quick, Simple and Paperless Documentation with Identity Based Authentication.</p>
          </div>
          <div class="clearfix visible-md visible-sm"></div>
          <div class="col-xs-12 col-md-6 col-lg-3 col-sm-6 subsection">
            <img src="../../../../../assets/images/finzy-flex-dashboard/automated-emi-collection.svg"
                 alt="We use automated emi collection"
                 class="img-responsive icon">
            <p class="heading">Automated EMI Collection</p>
            <p class="description">finzy collects monthly EMI electronically from multiple borrowers and consolidates the same on behalf of investors.</p>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-3 col-sm-6 subsection">
            <img src="../../../../../assets/images/finzy-flex-dashboard/recovery.svg"
                 alt="We ensure detailed follow-up and recovery"
                 class="img-responsive icon">
            <p class="heading">Follow up & Recovery</p>
            <p class="description">finzy has structured recovery process which comprises of calling, field visits and tie-ups with bank recognized agencies.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="section-why-invest-with-finzy" class="row grey-section">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">Why invest in finzy</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">We take care of your trust by assigning deserving credit rating to each borrower and supporting in investment, documentation, monthly collections, account reconciliation and recovery</p>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <div id="invest-with-finzy-carousel" class="carousel slide carousel-fade" data-ride="carousel"
             data-interval="3000">

          <div class="carousel-inner">
            <div id="carousel-simple-and-easy" class="row carousel-item item active">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading carousal-header">Simple and Easy</p>
                <p class="subheading carousal-subheader">Finzy supports you at every step:</p>
                <ul class="checklist carousal-checklist">
                  <li>Simplified documentation</li>
                  <li>Automating monthly collections and accounts reconciliation</li>
                  <li>Handling recovery process and supporting legal recourse</li>
                  <li>Visual dashboards for tracking investments</li>
                </ul>

                <button class="action-button carousal-btn invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel First Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="carousel-diversification" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading carousal-header">Liquidity</p>

                <p class="diversification-paragraph carousal-subheader liquidity-desc">finzyFLEX offers investors an option to withdraw investments post completion of Minimum Holding Period (<strong>MHP</strong>). </p>
                <p class="diversification-paragraph carousal-subheader liquidity-desc">Investment can be withdrawn in part or full as per investors choice. Click here to <a target="_blank" href="faq?selectedTab=FINZY_FLEX&liquidityCase=liquidity"><strong class="carousel-anchor">Know More</strong></a></p>
                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Second Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="carousel-credit-algorithm" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading carousal-header">Credit Algorithm</p>
                <p class="subheading carousal-subheader" id="credit-algorithm-subheading">Our credit assessment of a borrower is based on a proprietary scientific algorithm that takes into account as many as 130 parameters like:
                </p>

                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <ul class="checklist">
                      <li>Demographic Information</li>
                      <li>Leverage Ratios</li>
                    </ul>
                  </div>

                  <div class="col-xs-12 col-md-6">
                    <ul class="checklist">
                      <li id="leverage-ratios">No processing fees</li>
                      <li>Field verification and Database checks</li>
                    </ul>
                  </div>
                </div>

                <p>finzy ensures the investors have the choice to right borrowers.</p>
                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Third Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="carousel-transparency" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading carousal-header">Transparency</p>
                <p class="subheading carousal-subheader">finzy stands for transparency & trust, hence there are:</p>
                <ul class="checklist">
                  <li>No registration fees</li>
                  <li>No processing fees</li>
                  <li>No hidden charges</li>
                  <li>We earn a fee only when you earn</li>
                </ul>

                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Fourth Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>
          </div>

          <ol class="carousel-indicators">
            <li data-target="#invest-with-finzy-carousel" data-slide-to="0" class="active"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="1"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="2"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="3"></li>
          </ol>

          <a class="left carousel-control visible-lg" href="#invest-with-finzy-carousel"
             data-slide="prev">
            <img src="../../assets/images/carousel-arrows/arrow-left.svg" class="carousalArrow">
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control visible-lg" href="#invest-with-finzy-carousel"
             data-slide="next">
            <img src="../../assets/images/carousel-arrows/arrow-right.svg" class="carousalArrow">
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <app-core-team-section class="section grey-section"></app-core-team-section>

  <section id="section-client-testimonials" class="row grey-section" #clientTestimonials>
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">What our customers say</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
        Here is what investors who have experienced finzy have to say</p>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <div id="testimonials-carousel" class="carousel slide" data-ride="carousel" data-interval="3000">

          <div class="testimonial-cards carousel-inner">

            <div class="row item active">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Girish Vyasamudri, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539242301/testimonials/girish.jpg">
                    <p class="name">Girish Vyasamudri</p>
                    <p class="location">VP & Head of Operations at a Software Company,
                      Bangalore</p>
                    <p class="review">As someone who considers himself a seasoned investor, I
                      have been very
                      pleasantly surprised by the latest innovation on Finzy, namely
                      Reinvest-Pro. The feature not
                      only significantly reduces the risks and increases the returns, it also
                      does so in a very
                      seamless manner. The investor doesn't have to keep track of multiple
                      things and can let the
                      system work its magic, but still can change things any time he/she
                      wishes. A great addition to
                      the already attractive nature of the Finzy platform that every investor
                      has to take benefit
                      from.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row item">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Kuldeep Patnaik, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539242315/testimonials/kuldeep-pattanaik.jpg">
                    <p class="name">Kuldeep Patnaik</p>
                    <p class="location">Manager - Toyota, Bangalore</p>
                    <p class="review"> In this busy work life there isn't real scope
                      to understand investment options , evaluate them , and invest. Moreover,
                      the complications of
                      ups and downs of market impacting my investment. Finzy is strongly
                      recommended for people like
                      me... I started investing 8 months back and I am thoroughly impressed
                      with a consistent returns
                      of ₹ 13k coming to my account as interest each month with a wonderful
                      feature Reinvest-Pro. Now
                      this is what I love the most - finzy takes care of my investment with my
                      focus clearly on
                      returns and without need to understand the financial complexities.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row item">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Urmila Ramgharia, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539759781/testimonials/urmila_gz55an.jpg">
                    <p class="name">Urmila Ramgarhia</p>
                    <p class="location">Home Maker, Kolkata</p>
                    <p class="review">All my life , there was a sense of having
                      money but traditionally kept in fixed deposit with money at bank and
                      returns very less, till I
                      was introduced to finzy. Now all my FD has been moved to finzy and I get
                      almost 2.5 times FD
                      interest coming to me every month, that's smart - it helps me take care
                      of my monthly expenses
                      without depending on anybody + my investment is getting reinvested.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ol class="carousel-indicators">
            <li data-target="#testimonials-carousel" data-slide-to="0" class="active"></li>
            <li data-target="#testimonials-carousel" data-slide-to="1"></li>
            <li data-target="#testimonials-carousel" data-slide-to="2"></li>
          </ol>
        </div>
      </div>
    </div>
  </section>

  <app-we-have-been-in-the-news id="section-news-articles" class="row" #newsArticles></app-we-have-been-in-the-news>

  <section class="row grey-section">
    <app-awards-and-accreditations id="section-awards-and-accreditations"
                                  #awardsAndAccreditations></app-awards-and-accreditations>
  </section>
  <section class="row contact-us" id="contact-us">
    <div class="col-xs-10 col-lg-10 col-lg-offset-1 col-xs-offset-1">
        <app-contact-us form-position="left"></app-contact-us>
    </div>
  </section>
  <section class="row rbi-details">
    <div class="col-xs-12">
        <app-rbi-disclaimer class="rbi-disclaimer"></app-rbi-disclaimer>
    </div>
  </section>
</div>